/** Input styling shared by the note form, matching the contact form. */
export function inputClass(hasError?: boolean): string {
  return `block w-full rounded-lg border-2 px-4 py-3 text-sm bg-white text-gray-900 transition-colors duration-200 ${
    hasError ? 'border-red-300 focus:border-red-500' : 'border-gray-200 focus:border-[var(--color-indigo-60)] hover:border-gray-300'
  } focus:outline-none focus:ring-0`;
}

export const labelClass = 'block text-sm font-medium text-gray-700 mb-1';
